import { render, staticRenderFns } from "./StatisticPatternLab.vue?vue&type=template&id=68944571&scoped=true&"
import script from "./StatisticPatternLab.vue?vue&type=script&lang=js&"
export * from "./StatisticPatternLab.vue?vue&type=script&lang=js&"
import style0 from "./StatisticPatternLab.vue?vue&type=style&index=0&id=68944571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68944571",
  null
  
)

export default component.exports